import { BaseAPI } from '../BaseApi';
import { eAPITags } from '../eAPITags';
import { ILenderCompanyData } from '../../types/lenders/ILenderCompany';
import { ILenderCompaniesQuery } from '../../types/lenders/ILenderCompaniesQuery';
import { ILenderRequest } from '../../types/lenders/ILenderRequest';

export const LenderCompanyApi = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    listLenders: build.query<ILenderCompanyData[], ILenderCompaniesQuery>({
      query: (lenderCompaniesQuery) => {
        return {
          url: '/timber/api/internal/lender_companies',
          params: lenderCompaniesQuery,
        };
      },
      providesTags: (response, error, params) => [{ type: eAPITags.LenderCompanyData }],
    }),
    updateLender: build.mutation<ILenderCompanyData, { id: string; body: ILenderRequest }>({
      query: (request) => ({
        url: `/timber/api/internal/lender_companies/${request.id}`,
        method: 'PATCH',
        body: request.body,
      }),
      invalidatesTags: (result, error, params) => [{ type: eAPITags.LenderCompanyData }],
    }),
    createLender: build.mutation<ILenderCompanyData, ILenderRequest>({
      query: (request) => ({
        url: `/timber/api/internal/lender_companies`,
        method: 'POST',
        body: request,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useListLendersQuery, useUpdateLenderMutation, useCreateLenderMutation } = LenderCompanyApi;
